<template>
  <vs-input
    ref="mlInput"
    :type="type"
    class="ml-input"
    v-model="inputValue"
    :readonly="readonly"
    :disabled="disabled"
    :placeholder="placeholder"
    :icon-pack="iconPack"
    :icon="icon"
    :max="maxValue"
    :min="minValue"
    @keyup="(e) => $emit('keyup', e)"
    @click="(e) => $emit('click', e)"
    @focusout="(e) => $emit('focusout', e)"
    @blur="(e) => $emit('blur', e, inputValue)"
  />
</template>

<script>
import * as UiUtil from "@/util/UiUtil";

export default {
  name: "MaxLengthInput",
  props: {
    type: { type: String, default: "text" },
    value: { type: String | Number, default: "" },
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    max: { type: Number, default: 200 },
    iconPack: String,
    icon: String,
    noneCount: String,
    minValue: Number,
    maxValue: Number,
    renderFocus: Boolean,
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
    inputValue: {
      immediate: true,
      deep: true,
      handler(value) {
        // value에서 noneCount 문자를 모두 제거
        if (!!this.noneCount) value = value.replaceAll(this.noneCount, "");

        if (!!value && value.length > this.max) {
          this.inputValue = this.value;
          UiUtil.alertDialog(`${this.max}자까지 작성할 수 있습니다.`);
          // this.$refs.mlInput.focus();
        } else {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      },
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.renderFocus) this.$refs.mlInput.focusInput();
    });
  },
};
</script>

<style lang="scss" scoped>
.ml-input::v-deep {
  input {
    text-align: inherit;
  }
  .input-span-placeholder {
    line-height: 1.2rem;
  }
}
</style>
